import { forwardRef } from "react";
import type { TextareaHTMLAttributes } from "react";
import styles from "./Textarea.module.css";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ invalid, className, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        className={[styles.textarea, invalid ? styles.invalid : null, className]
          .filter(Boolean)
          .join(" ")}
        aria-invalid={invalid || undefined}
        {...rest}
      />
    );
  },
);
